export const LANGUAGES = [
  { label: "English", code: "en" },
  { label: "Mongolian", code: "mn" },
];
